import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss'],
    standalone: false
})
export class TitleComponent {
  @Input() titleRouter;
  @Input() backFuction: boolean = false;
  @Input() titleText: string;
  @Input() currentView: 'preview1' | 'preview2' | 'detail';
  @Output() returnDetails: EventEmitter<any> = new EventEmitter<any>();

  isRdsExterno: boolean;

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
  ) {
    this.isRdsExterno = this.localStorageService.getIsExternoRDS
  }

  goBack(): void {
    console.log('[title.goBack] INICIADO', {
      backFuction: this.backFuction,
      currentView: this.currentView,
      isRdsExterno: this.isRdsExterno
    });

    const isSpecialBack = this.backFuction || this.currentView === 'preview2' || this.currentView === 'detail';
    console.log('[title.goBack] isSpecialBack:', isSpecialBack);

    if (isSpecialBack) {
      console.log('[title.goBack] Emitiendo returnDetails');
      this.returnDetails.emit(true);
    } else {
      const list = this.localStorageService.getListBreadcrumb;
      const lentgh = list.length;
      const substract = lentgh > 1 ? 2 : 1;
      let url = "";

      if (lentgh > 1) {
        url = list[lentgh - substract].url !== '' ? `/${this.localStorageService.getIsVip
          ? 'vip'
          : this.localStorageService.getIsExternoRDS
            ? 'rdsportal'
            : 'int'}${list[lentgh - substract].url}` : '';
      } else {
        this.localStorageService.setMenuApp = null;
        url = this.localStorageService.getIsVip
          ? environment.URL_RETURN_APP_VIP
          : this.localStorageService.getIsExternoRDS
            ? environment.URL_RETURN_APP_RDS
            : environment.URL_RETURN_APP
      }

      console.log('[title.goBack] Navegando a:', url);
      this.router.navigateByUrl(url);
    }
  }

}
